import React, { memo } from 'react';
import { FormControlLabel, Switch as MuiSwitch } from '@mui/material';

import ControlledError from '../ControlledError';

import { useStyles } from './styles';

export interface ISwitchProps {
  checked?: boolean;
  label?: React.ReactNode;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  disabled?: boolean;
  styleClass?: string;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
}

const Switch = ({
  checked,
  color = 'primary',
  disabled = false,
  label,
  error,
  styleClass,
  onChange,
  onMouseDown,
}: ISwitchProps) => {
  const classes = useStyles();
  return (
    <ControlledError show={!!error} error={!!error && error}>
      <FormControlLabel
        control={<MuiSwitch disableRipple checked={checked} onChange={onChange} color={color} disabled={disabled} />}
        onMouseDown={onMouseDown}
        label={label}
        className={`${classes.switch} ${styleClass || ''}`}
      />
    </ControlledError>
  );
};

export default memo(Switch);
